module.exports = __webpack_public_path__ + "img/GALLERY-S-CROSS-1.2db986e5.jpg";